import apiConfig from 'http/services/api.config'
import apiService from 'http/services/api.service'
import { ApiResponse } from 'http/types/api-response'
import { Camera } from 'domain/camera'
import { CameraListResponse } from '../types/camera-list-response'
import { CameraQueryParams } from '../types/camera-query-parameters'

// src/services/camera.api.ts
class CameraApiService {
  private readonly baseUrl: string

  constructor() {
    this.baseUrl = apiConfig.endpoints.cameras
  }

  public async getCameras(
    params?: CameraQueryParams
  ): Promise<CameraListResponse> {
    return apiService.get<CameraListResponse>(
      this.baseUrl + `/${params?.clientId}`
    )
  }

  public async getCameraById(id: string): Promise<ApiResponse<Camera>> {
    return apiService.get<ApiResponse<Camera>>(`${this.baseUrl}/${id}`)
  }

  public async createCamera(cameraData: Camera): Promise<ApiResponse<Camera>> {
    const { model, ...rest } = cameraData
    return apiService.post<ApiResponse<Camera>>(
      `${this.baseUrl}/${cameraData.clientId}`,
      { ...rest, cameraModelId: model?.id }
    )
  }

  public async updateCamera(cameraData: Camera): Promise<ApiResponse<Camera>> {
    const { model, ...rest } = cameraData
    return apiService.put<ApiResponse<Camera>>(
      `${this.baseUrl}/${cameraData.id}`,
      { ...rest, cameraModelId: model?.id }
    )
  }

  public async deleteCamera(id: string): Promise<void> {
    return apiService.delete<void>(`${this.baseUrl}/${id}`)
  }
}

export const cameraApiService = new CameraApiService()
export default cameraApiService
